<template>
	<div class="custom-table" ref="tableCustom" id="table-scroll" :class="{'stage-table': obj.stageTable}">
		<table class="custom-table__table" id="table-test">
			<thead>
				<tr>
					<th class="custom-table__item"
						:class="{'custom-table__item--checkbox': obj.checkboxes && index === 0}"
						v-for="(field, index) in obj.fields"
						:key="field.key"
						@click="sortData($event, field.key)"
					>
						<div class="custom-table__item-chackbox">
							<!-- :sort-by="sort" -->
							<!--checkbox-->
							<!-- obj.checkboxes && -->
							<div class="checkbox-wrap" v-if="index === 0" @click.stop>
								<input
									type="checkbox"
									id="select-all"
									class="checkbox-select"
									v-if="obj.items.length > 0"
									v-model="isAllSelected" @click="selectAllCheckbox"
								>
								<label class="checkbox-label" for="select-all"></label>
							</div>
							<span class="checkbox-wrap__label">{{field.label}}</span>
							<SvgIcon class="sort-arrow" :class="[{'sort-arrow--down': field.key === column && order === 'desc'}, {'sort-arrow--up': field.key === column && order === 'asc'}]" iconName="ico-angle-down"/>
						</div>
					</th>
					<th class="email-btn fixed-last-col fixed-last-col"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="row in obj.items" :key="row.id">
					<template v-for="field in obj.fields">
						<td class="custom-table__td" :key="field.id" v-bind:class="isInContract(row.listing_status)">
							<template v-if="Array.isArray(row[field.key]) && field.key !== 'property_type_label' && field.key !== 'area_label'">
								<span class="block-item" v-for="el in row[field.key]" :key="el">
									{{el}}
								</span>
							</template>

							<!-- Property type with tooltip -->
							<template v-else-if="field.key === 'property_type_label'">
								<div class="td-tooltip-list custom-table-property">
									<span class="tooltip-wrap">
										<span class="table-list-item" @click="!isMobile()">
											<span  v-if="row.property_type_label.length < 2">{{row.property_type_label[0]}}</span>
											<span v-if="row.property_type_label.length > 1">Multiple Selection</span>
											<SvgIcon class="tooltip-dots" iconName="ico-ellipsis" v-if="row.property_type_label.length > 1"/>
										</span>
										<span class="tooltip-holder" v-if="toolTips">
											<span class="table-list-item-tooltip" v-if="row.property_type_label.length > 1" :class="{ 'table-list-item-tooltip--long': row.property_type_label.length > 6 }">
												<span v-for="item in row.property_type_label" :key="item">
													{{item}}
												</span>
												<div class="arrow-angle"></div>
											</span>
										</span>
									</span>
								</div>
							</template>
							<!-- Area with tooltip -->
							<template v-else-if="field.key === 'area_label'">
								<div class="td-tooltip-list">
									<span class="tooltip-wrap">
										<span class="table-list-item table-list-item-has-tooltip" @click="!isMobile()">
											<span v-if="row.area_label.length < 2">
												<template v-if="row.area_label[0] === 'Near Boro Park'">
													<span>Brooklyn</span>
												</template>
												<template v-else-if="row.area_label[0] === 'Near Brooklyn'">
													<span>New Jersey</span>
												</template>
												<template v-else>
													<span>{{row.area_label[0]}}</span>
												</template>
											</span>
											<span v-if="row.area_label.length > 1">Multiple Selection</span>
											<SvgIcon class="tooltip-dots" iconName="ico-ellipsis" v-if="row.area_label.length > 1"/>
										</span>
										<span class="tooltip-holder" v-if="toolTips">
											<span class="table-list-item-tooltip" v-if="row.area_label.length > 1" :class="{ 'table-list-item-tooltip--long': row.property_type_label.length > 6 }">
												<span v-for="item in row.area_label" :key="item">
													<template v-if="item === 'Near Boro Park'">
														<span>Brooklyn</span>
													</template>
													<template v-else-if="item === 'Near Brooklyn'">
														<span>New Jersey</span>
													</template>
													<template v-else>
														<span>{{item}}</span>
													</template>
												</span>
												<div class="arrow-angle"></div>
											</span>
										</span>
									</span>
								</div>
							</template>

							<template v-else-if="formatSF.includes(field.key)">
								<span v-if="row[field.key] || row[field.key] === 0">
									{{formatNumbers(row[field.key])}} SF
								</span>
							</template>

							<template v-else-if="formatDate.includes(field.key)">
									{{changeDateFormat(row[field.key])}}
							</template>

							<template v-else-if="formatPrice.includes(field.key)">
								<span v-if="row[field.key] || row[field.key] === 0">
									${{formatNumbers(row[field.key])}}
								</span>
							</template>

							<template v-else-if="field.key === 'last_name'">
								<!-- Checkbox -->
								<div class="checkbox-wrap" v-if="obj.checkboxes">
									<input
										type="checkbox"
										:id="row.id"
										v-model="checkedRowsCustomer"
										:value="row.id"
										@change="changeStageMany($event, {property_id: parseInt($route.params.id), customer_id: row.id })"
									>
									<label
										class="checkbox-label"
										:for="row.id"
									>
									</label>
									<router-link :to="{ name: goInDashboard() ? 'SingleCustomerPropertiesAdmin' : 'SingleCustomerPropertiesAgent', params: { id: row.id }}">
										{{row.last_name}} {{row.first_name}}
									</router-link>
									<!-- Critical notes tooltip -->
									<div v-if="row.critical_note !== null">
										<button class="critical-notes__icon" @click="show = !show">
											<SvgIcon :id="`${'last_name_' + row.last_name + '_' + row.id}`" iconName="ico-exclamation-mark" />
										</button>
										
										<b-popover
											:show="show && show === row.id"
											:target="`${'last_name_' + row.last_name + '_' + row.id}`" triggers="hover" placement="right"
											boundary="scrollParent"
											container="custom-table__table"
											boundary-padding="0">
											<div class="critical-notes__tooltip">
												{{row.critical_note}}
											</div>
										</b-popover >
									</div>
								</div>
								<span v-else>
									<router-link :to="{ name: goInDashboard() ? 'SingleCustomerPropertiesAdmin' : 'SingleCustomerPropertiesAgent', params: { id: row.id }}">
										{{row.last_name}} {{row.first_name}}
									</router-link>
								</span>
							</template>

							<template v-else-if="field.key === 'title'"> 
								<!-- <router-link class="img-link text-nowrap" :to="{ name: goInDashboard() ? 'SinglePropertyAdmin' : 'SinglePropertyAgent', params: { id: row.id }}"> -->
								<div class="property-img-cell-wrap">
									<div class="property-img-cell-checkbox-wrap">
										<input
											type="checkbox"
											:id="row.id"
											v-model="checkedRowsCustomer"
											:value="row.id"
											@change="changeStageMany($event, {customer_id: parseInt($route.params.id), property_id: row.id })"
										>
										<label
											class="checkbox-label"
											:for="row.id"
										>
										</label>
									</div>
									<router-link class="img-link text-nowrap" :to="{ name: goInDashboard() ? 'PropertyHistoryAdmin' : 'PropertyHistoryAgent', params: { id: row.id }}">
										<div class="table__img" :id="`${'img_' + row.thumbnail + '_' + row.id}`">
											<img :src="row.thumbnail" alt="img" v-if="row.thumbnail">
											<img :src="placeholderImg" alt="" v-else>
											<b-popover :target="`${'img_' + row.thumbnail + '_' + row.id}`" triggers="focus" :show="!row.thumbnail" class="table__img-tooltip" placement="bottomright" boundary="0">
												<img :src="row.thumbnail" alt="img" v-if="row.thumbnail">
											</b-popover>
										</div>
									</router-link>
									<div class="property-img-cell-wrap-text">
										<router-link class="img-link text-nowrap" :to="{ name: goInDashboard() ? 'PropertyHistoryAdmin' : 'PropertyHistoryAgent', params: { id: row.id }}">
											<span class="property-img-title">{{ row.title }}
												<span class="table__img-title-tooltip" v-if="row.title && row.title.length > 30">
													{{ row.title }}
													<span class="arrow-angle"></span>
												</span>
											</span>
										</router-link>
										<a class="property-img__link" target="_blank" href="" v-if="flagHide">
											<span><SvgIcon class="property-img__link-icon" iconName="ico-paperclip"/></span>
											<span>Flyer</span>
										</a>
									</div>
								</div>
							</template>
							<!-- Critical notes with tooltip -->
							<template v-else-if="field.key === 'critical_note'">
								<div class="td-tooltip-wrap">
									<span class="critical_note-text">
										{{row.critical_note}}
									</span>
									<span class="td-tooltip" v-if="row.critical_note && row.critical_note.length > 64">
										{{row.critical_note}}
										<div class="arrow-angle"></div>
									</span>
								</div>
							</template>
							<!-- Notes with tooltip -->
							<template v-else-if="field.key === 'note'">
								<div class="td-tooltip-wrap">
									<span class="critical_note-text">
										{{row.note}}
									</span>
									<span class="td-tooltip" v-if="row.note && row.note.length > 64">
										{{row.note}}
										<div class="arrow-angle"></div>
									</span>
								</div>
							</template>

							<template v-else-if="field.key === 'stage'">
								<div class="wrapper-dropdown stage-trigger" ref="customTableStage" @click="openStagesDrop($event, row.id)">

									<span class="dropdown__holder" :id="`${'stage_id_' + row.stage + '_' + row.id}`" :style="{background: row.color, color: '#000'}">
										{{ row.stage }}
									</span>
									<!-- Stages dropdown -->
									<b-popover class="dropdown_stages" :show="stagesOpened && choosenStage === row.id" :target="`${'stage_id_' + row.stage + '_' + row.id}`" placement="right" boundary="scrollParent" container="custom-table__table" boundary-padding="0" triggers="hover">
										<transition name="fade">
											<ul class="dropdown" v-on-click-outside.static="closeStagesDrop">
												<li class="color-picker__item" v-for="stage in allStages" :key="stage.id">
													<a v-if="!isPropertiesMatch()" class="dropdown__link" @click="changeStage({stageRow: row.stage, customer_id: parseInt($route.params.id), property_id: row.id, stage_id: stage.id, stage_name: stage.title }, stage.title, stage.datepicker)">
														<span class="color-picker__item-color" :style="{background: stage.color}"></span>
														<span class="color-picker__item-text">
															{{ stage.title }}
														</span>
													</a>
													<a v-else class="dropdown__link" @click="changeStage({stageRow: row.stage, property_id: parseInt($route.params.id), customer_id: row.id, stage_id: stage.id, stage_name: stage.title }, stage.title, stage.datepicker)">
														<span class="color-picker__item-color" :style="{background: stage.color}"></span>
														<span class="color-picker__item-text">
															{{ stage.title }}
														</span>
													</a>
												</li>
											</ul>
										</transition>
									</b-popover >
								</div>
							</template>
							<template v-else-if="field.key === 'property_shark_link'">
								<a class="external-link" :href="parseUrl(row.property_shark_link)" target="_blank">
									{{ parseUrl(row.property_shark_link) }}
								</a>
							</template>
							<template v-else-if="field.key === 'end_user'">
								<span v-if="row.end_user" class="investor-icon is-investor">
									<SvgIcon iconName="ico-checked"/>
								</span>
							</template>
							<template v-else-if="field.key === 'yearly_price'">
								<span v-if="(row.yearly_price || row.yearly_price === 0) && row.show_yearly_price">${{formatNumbers(row.yearly_price)}}</span>
							</template>
							<template v-else>
								{{row[field.key]}}
							</template>

						</td>
					</template>
					<td class="email-btn fixed-last-col fixed-last-col" v-if="isPropertiesMatch()" v-bind:class="isInContract(row.listing_status)">
						<a class="table-btn" :class="[{'table-btn--fade': (!row.primary_email && !row.secondary_email) && checkedRowsCustomer.length < 2}, {'table-btn--hidden': checkedRowsCustomer.length > 1}]" @click="sendEmail(row)">
							<span class="table-btn-icon">
								<SvgIcon iconName="ico-email"/>
							</span>
							<span class="table-btn-text">Send Email</span>
						</a>
					</td>
					<td class="email-btn fixed-last-col fixed-last-col" v-if="!isPropertiesMatch()" v-bind:class="isInContract(row.listing_status)">
						<a class="table-btn" :class="{'table-btn--fade': !obj.customerEmail}" @click="sendEmail(row)">
							<span class="table-btn-icon">
								<SvgIcon iconName="ico-email"/>
							</span>
							<span class="table-btn-text">Send Email</span>
						</a>
					</td>
				</tr>
			</tbody>
		</table>
		<BlockFormPopup
			v-if="activePopup"
			:class="{'active' : activePopup}"
			:data="popupData"
			class="popups-content"
			@closePopupForm="closePopupForm"
			@submitForm="submitForm"
		/>
	</div>
</template>
<script>
import { getDemoAsset, formatNumber, formatDate } from '@/config/util';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import BlockFormPopup from '@/components/blocks/BlockFormPopup';
import { BPopover } from 'bootstrap-vue';

export default {
	props: {
		obj: {
			type: Object,
			required: false
		},
		sort: {
			type: String,
			required: false
		},
		flagHide: {
			required: false
		},
		emptyCheckedRow: {
			type: Boolean,
			required: false
		},
		total: {
			required: false
		}
	},
	data: () => {
		return {
			show: false,
			activeColor: '',
			toolTips: true,
			placeholderImg: getDemoAsset('property/placeholder-50x50.png'),
			formatSF: ['building_size_max', 'building_size_min', 'lot_size_max', 'lot_size_min', 'lot_size', 'building_size'],
			formatPrice: ['price', 'price_max', 'price_min', 'regular_price', 'price_psf', 'price_psf_min', 'price_psf_max', 'price_buildable_sf', 'price_buildable_sf_max', 'price_buildable_sf_min', 'lease_price', 'lease_price_max', 'lease_price_min', 'yearly_price_min', 'yearly_price_max'],
			formatDate: ['created_at', 'date_listed', 'updated_at'],
			stagesOpened: false,
			activePopup: false,
			popupData: {
				popupId: 'popup_emailed',
				popupTitle: '',
				DataNoteArea: {
					label: 'Notes',
					inputId: 'note-popup-input',
					labelId: 'note-popup-label',
					classTextarea: 'small-area'
				},
				showCalendar: false,
				DataCalendar: {
					label: '',
					inputId: 'date_calendar-input',
					labelId: 'date_calendar-label',
					icon: true
				}
			},
			checkedRowsCustomer: [],
			isAllSelected: false,
			assStageObj: null,
			choosenStage: null,
			checkedRows: [],
			classScroll: 'prevent-scroll',
			customersWithEmail: [],
			order: 'asc',
			column: null,
			loaded: false,
			defaultColumn: null
		};
	},
	destroyed() {
		this.$store.dispatch('setCurrentSelected', { name: '', color: '', id: '' });
	},
	mounted() {
		// const self = this;
		this.$refs.tableCustom.addEventListener('scroll', this.infiniteScroll);
		this.column = this.sort;
		// this.$root.$on('sortData', function(data = false) {
		// 	self.loaded = data;
		// 	self.sortData(null, self.column);
		// });
	},
	components: {
		SvgIcon,
		BlockFormPopup,
		BPopover
	},
	computed: {
		allStages() {
			return this.$store.getters.getStages;
		},
		selectAll: {
			get: function() {
				return this.customersWithEmail ? (this.checkedRowsCustomer.length === this.customersWithEmail.length) && this.customersWithEmail.length !== 0 : false;
			},
			set: function(value) {
				const selected = [];

				if (value) {
					this.obj.items.forEach(function (el) {
						if (el.primary_email || el.secondary_email) {
							selected.push(el.id);
						}
					});
				}

				this.checkedRowsCustomer = selected;
			}
		},
		currentSelected() {
			return this.$store.getters.getCurrentSelected;
		}
	},
	watch: {
		currentSelected() {
			if (this.obj.items[0]) {
				if (this.currentSelected.name !== this.obj.items[0].stage) {
					this.checkedRowsCustomer = [];
					this.isAllSelected = false;
				}
			}
		},
		checkedRowsCustomer() {
			this.$emit('showBlastEmail', this.checkedRowsCustomer);
		},
		obj: {
			handler(val) {
				if (val.items) {
					(this.obj.items.length > 0) ? this.active = true : this.active = false;
					this.$emit('updateActive', this.active);
					if (this.obj.customersLead) {
						this.customersWithEmail = [];
						this.obj.items.forEach(el => {
							if (el.primary_email || el.secondary_email) {
								this.customersWithEmail.push(el);
							}
						});
					}
					if (!this.loaded && this.obj.items.length) {
						this.loaded = true;
					}
					this.obj.items.forEach((item, index) => {
						item.property_type_label.forEach((label, i) => {
							if (label.search('Comunity') > -1) {
								label = label.replace('Comunity', 'Community');
								this.obj.items[index].property_type_label[i] = label;
							}
						});
					});
				}
			},
			deep: true
		},
		emptyCheckedRow(val) {
			if (val) this.checkedRowsCustomer = [];
		}
	},
	beforeMount() {
		this.mobileTooltip();
	},
	mixins: [onClickOutside],
	methods: {
		selectAllCheckbox() {
			this.checkedRowsCustomer = [];
			const item = this.allStages.find(ele => ele.title === this.obj.items[0].stage);
			this.$store.dispatch('setCurrentSelected', { name: item.title, color: item.color, id: item.id });
			this.$store.dispatch('resetCustomPropertiesChangeStage');
			
			if (!this.isAllSelected) {
				this.obj.items.forEach(row => {
					this.checkedRowsCustomer.push(row.id);
					if (this.obj.history) {
						this.$store.dispatch('setCustomPropertiesChangeStage', {
							property_id: parseInt(this.$route.params.id),
							customer_id: row.id
						});
					} else {
						this.$store.dispatch('setCustomPropertiesChangeStage', {
							customer_id: parseInt(this.$route.params.id),
							property_id: row.id
						});
					}
				});
			} else {
				if (this.obj.history) {
					this.obj.items.forEach(row => {
						this.$store.dispatch('removeCustomPropertiesChangeStage', {
							property_id: parseInt(this.$route.params.id),
							customer_id: row.id
						});
					});
				} else {
					this.obj.items.forEach(row => {
						this.$store.dispatch('removeCustomPropertiesChangeStage', {
							customer_id: parseInt(this.$route.params.id),
							property_id: row.id
						});
					});
				}
			}
			this.isAllSelected = !this.isAllSelected;
			this.$store.dispatch('actionIsAllSelected', this.isAllSelected);
			this.$store.dispatch('actionIsAllSelectedProperty', this.isAllSelected);

			this.$store.dispatch('actionTotalSelectedInStage', {
				component: this.isAllSelected ? 'BlockCustomTable' : null,
				total: this.isAllSelected ? this.total : 0
			});
		},
		isInContract: function(status) {
			return status === 'in-contract' ? 'yellowbg' : '';
		},
		mobileTooltip() {
			if (window.innerWidth <= 640) {
				this.toolTips = false;
			}
		},
		isMobile() {
			if (this.toolTips !== true) {
				this.toolTips = true;
			} else {
				this.toolTips = false;
			}
		},
		infiniteScroll(e) {
			if (e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 400) {
				this.$emit('loadMore');
			}
			this.choosenStage = null;
			this.stagesOpened = false;
		},
		formatNumbers(field) {
			return formatNumber(field);
		},
		changeDateFormat(date) {
			return formatDate(date);
		},
		sortData(e, item) {
			if (item === 'stage' || item === 'property_shark_link') return;
			this.column = item;
			if (this.order === 'asc') {
				this.order = 'desc';
			} else {
				this.order = 'asc';
			}
			if (e !== null) {
				this.$emit('onSortLead', {
					sortBy: item,
					order: this.order
				});
				this.$emit('sortData', {
					sortBy: item,
					order: this.order
				});
			}
			this.$refs.tableCustom && this.$refs.tableCustom.scrollTo && this.$refs.tableCustom.scrollTo({ top: 0 });
		},
		openStagesDrop(e, id) {
			this.stagesOpened = true;
			this.choosenStage = id;
			// if (e.target.parentElement.parentElement) {
			// e.target.parentElement.parentElement.classList.add('opened-td');
			// }
		},
		closeStagesDrop() {
			this.choosenStage = null;
			this.stagesOpened = false;
			// if (document.querySelector('.opened-td')) {
			// document.querySelector('.opened-td').classList.remove('opened-td');
			// }
		},
		isPropertiesMatch() {
			return this.$route.fullPath.includes('properties');
		},
		changeStageMany(e, obj) {
			if (this.obj.items[0].stage !== this.currentSelected.name) {
				const item = this.allStages.find(ele => ele.title === this.obj.items[0].stage);
				this.$store.dispatch('setCurrentSelected', { name: item.title, color: item.color, id: item.id });
			}

			const { checked } = e.target;
			(checked) ? this.$store.dispatch('setCustomPropertiesChangeStage', obj) : this.$store.dispatch('removeCustomPropertiesChangeStage', obj);
			this.$store.dispatch('updateTotalSelectedInStage', checked);
			if (this.checkedRowsCustomer.length === 0) {
				this.isAllSelected = false;
			}
			if (this.checkedRowsCustomer.length === this.obj.items.length) {
				this.isAllSelected = true;
			}
		},
		changeStage(obj, title, datepicker) {
			this.popupData.popupTitle = title;
			this.popupData.showCalendar = datepicker;
			this.activePopup = true;
			this.assStageObj = obj;
			this.$refs.tableCustom.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.add(this.classScroll);
		},
		submitForm(data) {
			const obj = {
				customer_id: this.assStageObj.customer_id,
				property_id: this.assStageObj.property_id,
				stage_id: this.assStageObj.stage_id,
				stage_name: this.assStageObj.stage_name,
				stageRow: this.assStageObj.stageRow,
				stageRowId: this.assStageObj.stageRowId,
				history: [
					{
						body: data.note,
						stage: this.assStageObj.stage_name,
						popup_date: data.datepicker
					}
				]
			};
			this.$store.dispatch('resetCustomerSelectAll', false);
			this.$emit('updateStage', obj, true);
			this.closeStagesDrop();
			this.closePopupForm();
			// this.sortData(null, this.defaultColumn);
		},
		closePopupForm() {
			this.activePopup = false;
			this.$refs.tableCustom.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.remove(this.classScroll);
		},
		goInDashboard() {
			return this.$route.fullPath.includes('admin');
		},
		parseUrl(item) {
			if (item && !(item.startsWith('http://') || item.startsWith('https://'))) {
				item = 'https://' + item;
			}
			return item;
		},
		sendEmail(row) {
			const obj = {};
			if (this.$route.fullPath.includes('properties')) {
				obj.property_id = this.$route.params.id;
				obj.customer_id = row.id;
				obj.origin = 'property';
				obj.eretzPdf = this.obj.eretzPdf;
			} else {
				obj.customer_id = this.$route.params.id;
				obj.property_id = row.id;
				obj.origin = 'customer';
				obj.eretzPdf = row.eretz_pdf;
			}

			this.$emit('sendEmailPopup', obj);
		},
		resetSelectedCustomers() {
			this.checkedRows = [];
		},
		resetSelectedCustomersNew() {
			this.checkedRowsCustomer = [];
			this.isAllSelected = false;
		}
	}
};
</script>
<style lang="scss">
.b-popover[x-out-of-boundaries] {
  display: none !important;
}
.custom-table__td.yellowbg {
	background-color: #FFFCF0 !important;
}
td.email-btn.fixed-last-col.fixed-last-col.yellowbg {
	background-color: #FFFCF0 !important;
}
.custom-table-stage {
	min-width: 200px;
}

.cs-tb-property-type {
	max-width: 154px !important;
}

.sort-arrow {
	position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
	transition: $dur $ease;
	opacity: 0;

	&--up {
		transform: translateY(-50%) rotateX(-180deg);
		opacity: 1;
	}

	&--down {
		opacity: 1;
	}
}

.custom-table {
	max-height: 351px;
	overflow: auto;
	border-collapse: collapse;
	// transition: $dur $ease;
	position: relative;

	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}

	&::-webkit-scrollbar-track {
		background: #eceeef;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #42526e;
		border-radius: 20px;
		border: 1px solid #eceeef;
	}
	scrollbar-width: thin;
	scrollbar-color: #42526e #eceeef;

	&.stage-table {
		max-height: 400px;
	}

	/*&::before {
		content: '';
		background-color: $fiord;
		width: calc(100% - 12px);
		height: 44px;
		left: 0;
		top: 0;
		position: absolute;
		z-index: 10;

		@include mq($sm) {
			height: 40px;
			display: none;
		}
	}*/
}

table {
	position: relative;
}

.img-link {
    display: flex;
}

th {
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	align-items: center;
	color: $white;
	padding: 12px 25px 12px 14px;
	display: table-cell;
	z-index: 2;
	min-width: 100%;
	position: sticky;
	position: -webkit-sticky !important;//sass-lint:disable-line no-important
    top: 0;
    left: 0;
	background-color: $white;
	cursor: pointer;

	&:first-of-type {
		z-index: 13 !important;

		@include mq($sm) {
			min-width: 140px;
		}

		@include mq(400px) {
			min-width: 120px;
		}
	}

	&.email-btn {
		z-index: 9 !important;
	}
}

td {
	font-family: $font-main;
	font-size: 14px;
	line-height: 1,1;
	align-items: center;
	color: $fiord;
	border: none;
	border-top: none;
	vertical-align: inherit;
	padding: 7px 6px 7px 14px;
	display: table-cell;
	position: relative;
	transition: 0.2s $ease;
	word-wrap: break-word;
	white-space: normal;

	&.email-btn {
		background-color: $white;
	}

	&:first-of-type {
		position: sticky;
		position: -webkit-sticky !important;//sass-lint:disable-line no-important
		left: 0;
		z-index: 7;

		@include mq($sm) {
			min-width: 140px;
		}

		@include mq(400px) {
			min-width: 120px;
		}

		a {
			word-wrap: break-word;
			white-space: normal !important;
			transition: $dur $ease;

			@include hover {
				color: $dodger-blue;
			}
		}

		.checkbox-wrap {
			a {
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
			}
		}
	}

	@include mq($md) {
		font-size: 13px;
		padding: 10px;
	}

	@include mq($sm) {
		font-size: 12px;
	}

	&:focus {
		outline: none;
	}

	&.table-fixed-icon {
		background: transparent;
		background-color: transparent;

		@include mq($xl) {
			background: linear-gradient(to left, rgb(255, 255, 255) 86%,rgba(255, 255, 255, 0) 100%);

			&.edit {
				background: $white;
			}
		}
	}

	&.critical-notes {
		color: $orange;
	}

	&:first-of-type {
		border-right: none;
		position: sticky;
		position: -webkit-sticky !important;//sass-lint:disable-line no-important
		background-color: $white;
		z-index: 5 !important;//sass-lint:disable-line no-important
		max-width: 180px;
		min-width: 180px !important;//sass-lint:disable-line no-important
		padding: 10px 0 !important;//sass-lint:disable-line no-important

		@include mq($sm) {
			max-width: 140px;
			min-width: 140px !important;//sass-lint:disable-line no-important
		}

		@include mq(400px) {
			max-width: 120px;
			min-width: 120px !important;//sass-lint:disable-line no-important
		}

		/*&::after {
			content: '';
			height: 1px;
			width: 100%;
			background-color: $grey-light;
			position: absolute;
			left: 0;
			bottom: 0;
		}*/
	}

	&:not(:first-of-type) {
		z-index: 0;
	}

	a {
		font-family: $font-main;
		font-size: 14px;
		line-height: 20px;
		align-items: center;
		color: $fiord;
		border: none;
		border-top: 0;
		transition: $dur $ease;
		cursor: pointer;
		text-decoration: none;
		overflow: hidden;
		white-space: nowrap;
		display: block;
		max-width: 165px;
		text-overflow: ellipsis;

		@include mq($xl) {
			&:hover {
				color: $fiord;
				text-decoration: none;
			}
		}

		@include mq($md) {
			font-size: 13px;
		}

		@include mq($sm) {
			font-size: 12px;
		}

		@include hover {
			color: $fiord;
			text-decoration: none;
		}

	}
}

tr { 
	@include hover {
		td {
			&.email-btn {
				background-color: $white-lilac;
			}
		}
	}
}

.custom-table__item {
	min-width: 166px;
	/*max-width: 220px;*/
}

.custom-table__item-chackbox {
	display: flex;
	align-items: center;

	label {
		&::before {
			width: 18px !important;
			height: 18px !important;

			@include mq(830px) {
				width: 18px !important;
				min-width: 18px !important;
				height: 18px !important;
			}
		}

		&::after {
			top: 3px !important;
			width: 5px !important;

			@include mq(830px) {
				left: 11px !important;
				top: 3px !important;
			}
		}
	}
}

.custom-table__item--checkbox {
	.checkbox-wrap {
		position: absolute;
		left: 22px;
		display: block;

		@include mq(830px) {
			left: 10px;
		}
	}

	.checkbox-wrap__label {
		padding-left: 41px;

		@include mq(830px) {
			padding-left: 28px;
		}
	}
}

.checkbox-wrap__label {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.custom-table__table {
	overflow: auto;
	border-collapse: collapse;
	width: 100%;
}

.table thead th {
	position: sticky;
	position: -webkit-sticky !important;//sass-lint:disable-line no-important
	top: 0;
	z-index: 12 !important;
}

th, td {
	padding: 8px 16px;
}

/*--------------------------------------------------------------
## btn in table
--------------------------------------------------------------*/
.table-btn {
	display: inline-block;
	text-align: center;
	color: $white;
	padding: 8px 10px;
	outline: none;
	max-width: 123px;
	width: 100%;
	transition: $dur $ease;
	cursor: pointer;
	background-color: $dodger-blue;
	border-radius: 8px;
	border: 1px solid $dodger-blue;
	position: relative;
	font-family: $font-main;
	font-weight: 500;
	font-size: 14px;
	line-height: 1.1;
	min-width: fit-content !important;//sass-lint:disable-line no-important

	@include hover {
		background-color: $white;
		color: $dodger-blue;
		.table-btn-text {
			color: $dodger-blue;
		}
	}

    &.sent-email {
        background-color: $shuttle-gray;
    }

	@include mq($md) {
		height: 40px;
		max-width: 40px;
		border: none;
		background-color: transparent;
		color: $dodger-blue;
		padding: 0;
		display: flex;
		align-items: center;

		.table-btn-icon {
			display: block;
		}
		.table-btn-text {
			display: none;
		}
	}

	/*@include mq($sm) {
		max-width: 25px !important;//sass-lint:disable-line no-important
	}*/

	&--hidden {
		visibility: hidden;
		opacity: 0;
		pointer-events: none;
	}

	&--fade {
		opacity: .5;
		pointer-events: none;

		@include hover {
			border: 1px solid $fiord;
			background-color: $fiord;
			color: $white;
		}
	}
}

td {
	.checkbox-wrap {
		width: auto;
		height: auto;
		margin: 0;
		display: flex;
		align-items: flex-start;
		padding: 17px 25px 17px 15px;
		background-color: $white-lilac;
		border-radius: 14px;

		@include mq($md) {
			padding: 15px 25px 15px 15px;
		}

		@include mq($sm) {
			padding: 10px 20px 10px 12px;
		}

		a {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}

	.checkbox-label {
		position: relative !important;//sass-lint:disable-line no-important
		top: auto !important;//sass-lint:disable-line no-important
	}
}

.email-btn {
	z-index: 4 !important;//sass-lint:disable-line no-important

	@include mq($md) {
		text-align: center;
		min-width: 40px !important;//sass-lint:disable-line no-important
		max-width: 40px !important;//sass-lint:disable-line no-important
	}
}

td {
	&.fixed-last-col {
		right: 0;
		position: sticky !important;//sass-lint:disable-line no-important
		position: -webkit-sticky !important;//sass-lint:disable-line no-important
	}
}
.block-item {
	display: block;
	width: 100%;
	max-width: 100%;
}

/*--------------------------------------------------------------
## color picker
--------------------------------------------------------------*/
.dropdown__holder {
	padding: 3px 27px 3px 10px;
	cursor: pointer;
	position: relative;
	font-family: $font-main;
	font-size: 14px;
	line-height: 20px;
	max-width: 110px;
	min-width: 80px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: block;
	transition: $dur $ease;
	border-radius: 8px;
	color: $white !important;

	@include mq(440px) {
		min-width: 65px;
		padding: 3px 20px 3px 10px;
	}

	&::after,
	&::before {
		border-right: 2px solid;
		content: '';
		display: block;
		height: 5px;
		margin-top: -4px;
		position: absolute;
		transform: rotate(135deg);
		right: 10px;
		top: 50%;
		width: 0;
	}

	&::after {
		margin-top: -1px;
		transform: rotate(45deg);
	}
}
.wrapper-dropdown {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-right: 10px;
	transition: $dur $ease;
	min-width: 170px;

	@include hover {
		.dropdown__holder {
			opacity: 0.8;
		}
	}
}

.color-picker__item {
	display: flex;
	align-items: center;
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;
	color: $fiord;
	margin-bottom: 10px;
	cursor: pointer;
	transition: $dur $ease;
	width: 100%;

	@include mq($md) {
		font-size: 12px;
		margin-bottom: 5px;
	}

	@include hover {
		.dropdown__link,
		.color-picker__item-text {
			color: $dodger-blue;
		}
	}
}

.color-picker__item-color {
	width: 12px;
	min-width: 12px;
	height: 12px;
	display: block;
	border-radius: 50%;
	position: absolute;
	left: 0;

	@include mq(440px) {
		width: 10px;
		min-width: 10px;
		height: 10px;
	}
}

.dropdown__link {
	display: flex;
	align-items: center;
	max-width: 100%;
	padding-left: 25px;
	position: relative;
	z-index: 2;
	width: 100%;

	.color-picker__item-text {
		width: auto;
		height: auto;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;

		@include mq($xl) {
			padding-left: 10px;
		}

		@include mq(512px) {
			padding-left: 0;
		}
	}
	@include mq(512px) {
		padding-left: 0;
	}

	@include hover {
		.color-picker__item-text {
			color: $dodger-blue;
		}
	}
}

.overlay-phone {
	position: fixed;
	width: 100%;
	height: 100%;
	background-color: $red;
	left: 0;
	top: 0;
	opacity: 0;
	visibility: hidden;
	pointer-events: all;
}

.dropdown_stages {
	left: 90px;
	top: 0;

	@include mq(640px) {
		margin-top: 0;
		position: fixed !important;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}

.popups-content {
	visibility: hidden;
	backface-visibility: hidden;
	transition: $dur $ease;
	opacity: 0;

	&.active {
		opacity: 1;
		transition: $dur $ease;
		visibility: visible;
	}
}

.property-img-title {
	line-height: 20px;
	display: -webkit-box;
	height: 100% !important;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	max-height: 41px;

	&:hover {
		.table__img-title-tooltip {
			opacity: 1;
			visibility: visible;
		}
	}
}

/* Checkbox */
.checkbox-wrap {
	position: relative;
	line-height: 1;
	width: 20px;
	height: 20px;
	margin-right: 17px;

	&:not(:last-of-type) {
		margin-bottom: 15px;
	}

	&--no-check {
		position: relative;
		a {
			padding-left: 30px;
		}
	}
}

.checkbox-label {
	font-family: $font-main;
	display: flex;
	margin-bottom: 0;
	color: $fiord;
	font-size: 14px;
	line-height: 20px;
	position: absolute !important;
	top: 0 !important;

	&::before {
		width: 18px !important;
		min-width: 18px !important;
		height: 18px !important;
		min-height: 18px !important;
	}

	&::after {
		top: 3px !important;
		width: 5px !important;
	}
}

[type='checkbox']:checked,
[type='checkbox']:not(:checked) {
	position: absolute;
	left: -9999px;
}

[type='checkbox']:checked + label,
[type='checkbox']:not(:checked) + label {
	position: relative;
	padding-left: 31px;
	cursor: pointer;
	line-height: 20px;
	transition: $dur $ease;
	display: inline-block;

	@include mq($lg) {
		padding-left: 30px;
	}
}

[type='checkbox']:checked + label:before,
[type='checkbox']:not(:checked) + label:before {
	content: '';
	position: absolute;
	left: 4px;
	top: 0;
	width: 20px;
	height: 20px;
	border: 2px solid $white-lilac;
	box-sizing: border-box;
	border-radius: 4px;
	background: $white;
	transition: $dur $ease;

	@include mq($lg) {
		width: 15px;
		height: 15px;
	}
}

[type='checkbox']:checked + label:after,
[type='checkbox']:not(:checked) + label:after {
	content: '';
	position: absolute;
	left: 11px;
	top: 4px;
	width: 6px;
	height: 10px;
	transition: $dur $ease;
	border: solid $dodger-blue;
	border-width: 0 2px 2px 0;
	transform: rotate(45deg);

	@include mq($lg) {
		left: 10px;
		top: 2px;
		width: 4px;
		height: 9px;
	}
}

[type='checkbox']:not(:checked) + label:after {
	opacity: 0;
	transform: scale(0) rotate(45deg);
}

[type='checkbox']:checked + label:after {
	opacity: 1;
	transform: scale(1) rotate(45deg);
}

[type='checkbox']:checked + label:before {
	background: $white-lilac;
	border: 2px solid $white-lilac;
}
.arrow-angle {
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 5px 12px 8px;
	border-color: transparent transparent #fff transparent;
	top: 0;
	position: absolute;
	left: -9px;
	transform: rotate(-90deg) translateX(-50%);
	box-shadow: 1px 1px 15px -5px #000;
	z-index: 8;
}

.table__img-title-tooltip {
	box-shadow: 1px 1px 15px -5px $black;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: 100%;
	width: 100%;
	font-size: 12px;
	background-color: $white;
	border-radius: 8px;
	padding: 5px;
	opacity: 0;
	visibility: hidden;
	transition: all 0.75s ease;
	font-family: $font-main;
	line-height: 1.2;
	text-align: left;
	max-width: fit-content;
	color: $fiord;
	z-index: 9;
	pointer-events: none;
}

.table-list-item {
	display: flex;
	align-items: center;
    width: 100%;
    justify-content: space-between;
}

.custom-table__td {
	max-width: 350px;
	border: none !important;
	border-collapse: collapse;

	.external-link {
		color: $dodger-blue;
		&:hover {
			text-decoration: underline;
		}
	}
	&:hover {
		z-index: 1 !important;
	}

	&:first-of-type {
		&:hover {
			z-index: 11 !important;
		}
	}
}

td {
	&:first-of-type {
		&::after {
			display: none;
		}
	}
}

.accordion-custom-table__content {
	.property-img-cell-wrap {
		display: flex;	
		padding: 6px;
		flex-direction: row;
		margin-right: 0;

		.img-link {
			width: 150px;
			min-width: 150px;
			margin-right: 17px;

			@include mq($md) {
				width: 100px;
				min-width: 100px;
				margin-right: 10px;
			}

			@include mq($sm) {
				width: 60px;
				min-width: 60px;
			}
		}

		.table__img {
			margin: 0;
		}

		@include mq($sm) {
			padding: 10px 6px;
		}
	}

	.property-img-cell-wrap-text {
		.img-link {
			padding: 0;
			margin: 0;
			margin-bottom: 16px;

			@include mq($md) {
				margin-bottom: 0;
			}
		}

		.property-img-title {
			max-width: 100%;
		}
	}
}

.property-img-cell-checkbox-wrap {
    position: absolute;
	left: 12px;
    top: 3px;
}

.popup__wrap-match {
	.custom-table__td {
		&:first-of-type {
			span {
				display: block;
				padding: 17px 25px;
				background-color: $white-lilac;
				border-radius: 14px;

				@include mq($md) {
					padding: 15px;
				}

				@include mq($sm) {
					padding: 10px 12px;
				}

			}
		}
	}
}

</style>
